export default "__VITE_PUBLIC_ASSET__a7573b94__"